import { httpClient } from '@/Common/api/http_client';

// =========================================
// Merchant Specific APIs starts
/**
 *
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getAllSuppliersGroups() {
  return httpClient.get('/merchant/suppliers-groups');
}

/**
 *
 * @param groupId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function deleteSuppliersGroup(groupId) {
  return httpClient.delete(`/merchant/suppliers-groups/${groupId}`);
}

/**
 *
 * @param groupId
 * @param status
 * @returns {Promise<AxiosResponse<T>>}
 */
export function updateSuppliersGroup(groupId, status) {
  return httpClient.put(`/merchant/suppliers-groups/${groupId}`, status);
}

/**
 *
 * @param suppliers_group
 * @returns {*}
 */
export function newSuppliersGroup(suppliers_group) {
  return httpClient.post('/merchant/suppliers-groups', suppliers_group);
}

// Merchant Specific APIs ends
// =========================================
